import PastEvents from './PastEvents';

export default PastEvents;
